var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "889.03 350.73 73.14 73.14",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M922.4,412.6c-1,0-1.9-0.4-2.6-1.1c-0.7-0.7-1.1-1.6-1.1-2.6v-18.3L901,367.9c-0.9-1.2-1.1-2.5-0.4-3.9   c0.7-1.4,1.8-2,3.4-2h43.2c1.6,0,2.7,0.7,3.4,2c0.7,1.4,0.5,2.7-0.4,3.9l-17.7,22.7v18.5c0,1-0.3,1.8-1,2.5c-0.7,0.7-1.5,1-2.5,1   H922.4z M925.5,387.8l14.8-18.8h-29.6L925.5,387.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterWhite);
export default __webpack_public_path__ + "static/media/filterWhite.b56108761cc30297e56aa3e65869dc8e.svg";
export { ForwardRef as ReactComponent };